import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Scroll to top on every link/button navigation (also same-URL); browser Back/Forward keeps its position.
const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== 'POP') window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, key, navType]);

  return null;
};

export default ScrollToTop;
